var d3 = require('d3');
require('imports?this=>window!d3.chart');
require('notifier');
require('basewidget');
var i18n = require('i18n');
require('utilities');
// require('domotooltip');
var datheme = require('da-theme');
var _ = require('lodash');
var ComparisonBarChart = require('comparisonbarchart');

/*----------------------------------------------------------------------------------
----------------------------------------------------------------------------------
// MultiMetricComparisonBarChart:
----------------------------------------------------------------------------------
----------------------------------------------------------------------------------*/
d3.chart('BaseWidget').extend('MultiMetricComparisonBarChart', {
  initialize: function() {
    'use strict';

    var _Chart = this;

    _Chart._dataObject = {};

    //----------------------------------------------------------------------------------
    // Config
    //----------------------------------------------------------------------------------
    this._newConfig = {
      //plugin user configable configs
      barHeight: {
        name: 'Bar Height',
        description: 'Height of the comparison bar',
        category: 'Bars',
        value: 30,
        type: 'number',
        units: 'px'
      },
      chartGap: {
        name: 'Chart gap',
        description: 'Sets the gap between each chart',
        value: 10,
        type: 'number',
        units: 'px'
      },
      generalWashoutColor: datheme.te.generalWashoutColor(),

      //----------------
      // TEXT
      //----------------
      textFontFamily: datheme.te.textFontFamily(),

      //----------------
      // TITLE
      //----------------
      titleWeight: {
        name: 'Title Font Weight',
        description: 'Font weight for the title text',
        category: 'General',
        value: 700,
        type: 'number',
        units: ''
      },
      titleSize: {
        name: 'Title Text Size',
        description: 'Text size of the title',
        category: 'General',
        value: 12,
        type: 'number',
        units: 'px'
      },
      titleColor: datheme.te.textColor({
        name: 'Title Text Color',
        description: 'Color for the title text'
      }),


      //----------------
      // LABELS
      //----------------
      labelSize: {
        name: 'Label Size',
        description: 'Text size of labels',
        category: 'General',
        value: 12,
        type: 'number',
        units: 'px'
      },
      labelColor: datheme.te.chartLabelColor(),

      //----------------
      // GENERAL
      //----------------
      showAnimations: {
        name: 'Show Animations',
        description: 'Shows or hides animations',
        category: 'Animation',
        value: true,
        type: 'boolean'
      },

      //widget default configs
      chartName: {
        description: 'Name of chart for reporting',
        type: 'string',
        value: 'MultiMetricComparisonBarChart'
      },
      chartPrimarySeriesColors: datheme.te.chartPrimarySeriesColors()
    };
    this.mergeConfig(_Chart._newConfig);

    //----------------------------------------------------------------------------------
    // Data Definition:
    //----------------------------------------------------------------------------------
    _Chart._newDataDefinition = {
      'Metric': {
        type: 'string',
        validate: function(d) { return this.accessor(d) !== undefined; },
        accessor: function(line) { return String(line[0]); }
      },
      'Label': {
        type: 'string',
        validate: function(d) { return this.accessor(d) !== undefined; },
        accessor: function(line) { return String(line[1]); }
      },
      'Value': {
        type: 'number',
        validate: function(d) { return !isNaN(this.accessor(d)) && this.accessor(d) > 0; },
        accessor: function(line) { return Number(line[2]); }
      }
    };
    this.mergeDataDefinition(_Chart._newDataDefinition);

    //----------------------------------------------------------------------------------
    // Static - Anything that is defined here will never change
    // If extending 'BaseWidget' : _Chart._layerGroup is the NEW BASE
    //----------------------------------------------------------------------------------
    var _manualColorScale = false;
    var _colorScale = d3.scale.ordinal();

    _Chart._chartGroup = _Chart._layerGroup.append('g').attr('class', 'chartGroup');

    _Chart.transform = function(data) {
      var validData = _Chart.validateData(data);

      calculateTextHeight();
      moveNotifier();
      initChartVariables(validData);
      setColorScale();

      return validData;
    };

    //----------------------------------------------------------------------------------
    // Layers:
    //----------------------------------------------------------------------------------
    _Chart.layer('chartGroup', this._chartGroup, {
      dataBind: function(validData) {
        var data = validData.metrics;
        return this.selectAll(' g.chart').data(data);
      },
      insert: function() {
        return this.append('g');
      }
    })
    .on('enter', function() {
      // adds chart to group
      this.each(function(d, i) {

        this.__chart__ = d3.select(this)
          .chart('ComparisonBarChart')
          .c('showAnimations', false)
          .on('dispatch:mouseenter', function(obj, element) { hoverAll(obj, element); })
          .on('dispatch:mouseleave', function(element) { unhoverAll(element); });
      });
      return this.classed('chart', true);
    })
    .on('merge', function() {
      this.attr('transform', function(d, i) {

        return 'translate(0,' + (i * (_Chart.innerChartHeight + _Chart.c('chartGap'))) + ')';
      });

      this.each(function(d, i) {
        this.__chart__
          .c('height', _Chart.innerChartHeight)
          .c('width', _Chart.c('width'))
          .c('barHeight', _Chart.c('barHeight'))
          .c('chartPrimarySeriesColors', _Chart.c('chartPrimarySeriesColors'))
          .c('textFontFamily', _Chart.c('textFontFamily'))
          .c('title', d)
          .c('titleWeight', _Chart.c('titleWeight'))
          .c('titleSize', _Chart.c('titleSize'))
          .c('titleColor', _Chart.c('titleColor'))
          .c('labelSize', _Chart.c('labelSize'))
          .c('labelColor', _Chart.c('labelColor'))
          .c('generalWashoutColor', _Chart.c('generalWashoutColor'))
          .c('showAnimations', false)
          .draw(_Chart._dataObject[d]);
      });

      return this;
    })
    .on('exit', function() {
      return this.remove();
    });

    //----------------------------------------------------------------------------------
    // Event Functions
    //----------------------------------------------------------------------------------
    /**
     * Sets off dispatch:mouseenter:bar trigger event. If _Chart.c('showAnimations') is true,
     * it changes the color of the opposite bar to generaWashoutColor
     * @param  {[Object]} obj   Object with series, name, and data properties
     * @param  {[SVG]} element 	SVG element that is being hovered over
     */
    function hoverAll(obj, element) {
      var thisClass = d3.select(element).classed('left') ? 'left' : 'right';
      _Chart.trigger('dispatch:mouseenter:bar', obj, element);

      if (_Chart.c('showAnimations')) {
        setWashoutColorOnHover(thisClass);
      }
    }

    /**
     * Changes color of opposite bar and label to generalWashoutColor
     * @param {[String]} thisClass Class of the element that is being hovered
     */
    function setWashoutColorOnHover(thisClass) {
    	_Chart._chartGroup.selectAll('rect.bar')
          .filter(function() {
            return !d3.select(this).classed(thisClass);
          })
          .transition()
          .style('fill', _Chart.c('generalWashoutColor'));

        _Chart._chartGroup.selectAll('g.label')
          .filter(function() {
            return !d3.select(this).classed(thisClass);
          })
          .selectAll('text.labelText')
          .transition()
          .style('fill', _Chart.c('generalWashoutColor'));
    }

    /**
     * Sets off dispatch:mouseleave:bar trigger event. If _Chart.c('showAnimations') is true,
     * it changes the color of the opposite bar to its original color
     * @param  {[SVG]} element SVG element that was hovered off of
     */
    function unhoverAll(obj, element) {
      _Chart.trigger('dispatch:mouseleave:bar', obj, element);

      if (_Chart.c('showAnimations')) {
       setColorOnHoverOff();
      }
    }

     /**
     * Changes color of opposite bar and label to their original colors
     * @param {[String]} thisClass Class of the element that is being hovered
     */
    function setColorOnHoverOff() {
    	 _Chart._chartGroup.selectAll('rect.bar')
          .transition()
          .style('fill', function(d, i) {
            return _colorScale(i);
          })
          .style('opacity', 1);

        _Chart._chartGroup.selectAll('g.label')
          .selectAll('text.labelText')
          .transition()
          .style('fill', _Chart.c('labelColor'))
    }

    //----------------------------------------------------------------------------------
    // Helper Functions
    //----------------------------------------------------------------------------------

    /**
     * Initiates the charts variables
     * @param  {[Array]} validData 2D array of data
     * @return {[Array]} validDAta 2D array of data with a metrics property
     */
    function initChartVariables(validData) {
      // saves the data in this object with a hierarchy
      _Chart._dataObject = {};
      // passes only the metrics onto the layer
      var metrics = [];
      // loop through to add hieararchy
      getMetrics(metrics, validData);
      var chartSize = metrics.length * (_Chart.innerChartHeight + _Chart.c('chartGap'));
      var excessData = [];
      //Remove excess data from metrics
      removeExcessData(excessData, chartSize, metrics);
      //If there is excess data, notify the user.
      excessDataNotifier(excessData);
      validData.metrics = metrics;
      return validData;
    }

    /**
     * Removes excess data so the chart doesn't draw more bars than what the height can hold
     * @param  {[Array]} excessData Empty array
     * @param  {[Number]} chartSize Size of the chart to accomodate all of the bars drawn
     * @param  {[Array]}  metrics   Array of strings that represent the metrics that are being measured
     */
    function removeExcessData(excessData, chartSize, metrics) {
      while (chartSize > _Chart.c('height')) {
        excessData.push(metrics.pop());
        chartSize = metrics.length * (_Chart.innerChartHeight + _Chart.c('chartGap'))
      }
    }

    /**
     * Notifies the user if any of the data is removed
     * @param  {[Array]} excessData Array of the excess data
     */
    function excessDataNotifier(excessData) {
      if (excessData.length > 0) {
        _Chart._notifier.base.attr('transform', 'translate(0,-20)')
        _Chart._notifier.appendMessage(_Chart.c('chartName'), 'DISCARDED_VALID_DATA',
          'There are too many bars for chart\'s height!', ['Metric:String', 'Label:String', 'Value:Number'], excessData);
        _Chart._notifier.draw();
      }
    }

    /**
     * Loops through the data and sets its metrics and _Chart._dataObject
     * @param  {[Array]} metrics   Empty array
     * @param  {[Array]} validData 2D array of data
     */
    function getMetrics(metrics, validData) {
      for (var i = 0; i < validData.length; i++) {
        var metric = _Chart.a('Metric')(validData[i]);
        var array = [
          _Chart.a('Label')(validData[i]),
          _Chart.a('Value')(validData[i])
        ];
        // checks if metric already exists in object
        if (_Chart._dataObject[metric] === undefined) {
          _Chart._dataObject[metric] = [];
          metrics.push(metric);
        }
        // adds array under metric
        // only allows 2 per metric
        if (_Chart._dataObject[metric].length <= 2) {
          _Chart._dataObject[metric].push(array);
        } else {
          _Chart._notifier.appendMessage(_Chart.c('chartName'), 'WARN', 'Too many rows', validData[i]);
        }
      }
    }

    /**
     * Set the color scale for the chart
     */
    function setColorScale() {
      if (!_manualColorScale) {
        _colorScale = d3.scale.ordinal()
          .domain(0, 1)
          .range(datheme.getPrimaryColorsForNumberOfSeries(2, _Chart.c('chartPrimarySeriesColors')));
      }
    }

    function calculateTextHeight() {
      var title = _Chart._layerGroup.append('text')
        .classed('tempText', true)
        .text('title')
        .style('font-size', _Chart.c('titleSize'))
        .style('font-family', 'Open Sans')
        .style('opacity', 0);

      var label = _Chart._layerGroup.append('text')
        .text('label')
        .classed('tempText', true)
        .style('font-size', _Chart.c('labelSize'))
        .style('font-family', 'Open Sans')
        .style('opacity', 0);

      var titleHeight = title.node().getBBox().height * 0.9;
      var labelHeight = label.node().getBBox().height * 0.9;
      _Chart.titleHeight = titleHeight;

      _Chart.textHeight = titleHeight + labelHeight;
      _Chart._layerGroup.selectAll('.tempText').remove();
      _Chart.innerChartHeight = _Chart.c('barHeight') + _Chart.textHeight;

    }

    function moveNotifier() {
      _Chart._notifier.base.attr('transform', 'translate(0,' + (-_Chart.titleHeight) + ')');
    }

    //----------------------------------------------------------------------------------
    // Public Functions
    //----------------------------------------------------------------------------------
    _Chart.colorScale = function(_) {
      console.log('hi');
      if (_) {
        _manualColorScale = true;
        _colorScale = _;
        return _Chart;
      } else {
        return _colorScale;
      }
    };
  }
});




/*****************
 ** WEBPACK FOOTER
 ** ./MultiMetricComparisonBarChart.js
 ** module id = 0
 ** module chunks = 0
 **/